<script>
    import { getStroke } from 'perfect-freehand'
	import { onMount } from 'svelte'
    import { getSvgPathFromStroke } from '../utils';
    import { draw } from 'svelte/transition';
    import { linear } from 'svelte/easing'
	
	export let width = Math.min(window.innerWidth * 0.90, 512)
	export let height = Math.min(window.innerHeight * 0.90, 512)
    width = Math.min(width, height);
    height = width;
	// export let color = '#000'
	// export let background = '#fff'
    export let drawing = false
    export let disabled = false
	
	let svg
	let isDrawing
	let start

    let hist = []
    let stroke_width = 4

    let playing = false
    let maxtime = 6000; // ms
    let duration = 0;

    let points = []
    let stroke 
    let pathData 

    let isnew = true

    let t, l

    onMount(() => {
		handleSize()
	})

    const setSVGdata = () => {
        stroke = getStroke(points, {
            size: 1,
            smoothing: 0,
            thinning: 1,
            streamline: 0.5,
            })
        pathData = getSvgPathFromStroke(stroke)
    }
	
	const handleStart = ((e) => { 
        let x = e.offsetX;
        let y = e.offsetY;
        //console.log("start");
        isDrawing = true
        start = { x, y }
        points = [[x, y, 1]]
        setSVGdata()
	})
	
	const handleEnd = () => {
        //console.log("end");
        if (points.length == 0) return;
        isDrawing = false
        hist = [...hist, [pathData, stroke_width > 15 ? 15 : stroke_width]]
        pathData = undefined
        points = []
        drawing = true
        isnew = false
    }

	const handleMove = (({ offsetX: x1, offsetY: y1 }) => {
        //console.log("move");
		if(!isDrawing) return
		
		const { x, y } = start
        points.push([x, y, 1])
        setSVGdata()
		
		start = { x: x1, y: y1 }
	})

    const clear = () => {
        drawing = false
        hist = []
        pathData = undefined
    }

    const undo = () => {
        if (hist.length <= 1) {
            drawing = false
        }
        hist.pop()
        hist = hist
        pathData = undefined
    }

    const triggerDownload = (imgURI) => {
        var evt = new MouseEvent('click', {
            view: window,
            bubbles: false,
            cancelable: true
        });

        var a = document.createElement('a');
        a.setAttribute('download', 'MY_COOL_IMAGE.png');
        a.setAttribute('href', imgURI);
        a.setAttribute('target', '_blank');

        a.dispatchEvent(evt);
    }

    const save = () => {
        var canvas = document.getElementById('canvas');
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, width, height);
        var data = (new XMLSerializer()).serializeToString(svg);
        var DOMURL = window.URL || window.webkitURL || window;

        var img = new Image();
        var svgBlob = new Blob([data], {type: 'image/svg+xml;charset=utf-8'});
        var url = DOMURL.createObjectURL(svgBlob);

        img.onload = function () {
            ctx.drawImage(img, 0, 0);
            DOMURL.revokeObjectURL(url);

            var imgURI = canvas
                .toDataURL('image/png')
                .replace('image/png', 'image/octet-stream');

            // TODO: Aqui no hauriem de descarregar l'imatge, sino
            //      que hauriem de enviar l'url al backend per a que li passin a l'api
            triggerDownload(imgURI);
        };

        img.src = url;
    }

    const play = () => {
        duration = maxtime / hist.length;
        playing = !playing;
    }

    const handleSize = () => {
		const { top, left } = svg.getBoundingClientRect()
		t = top
		l = left
        width = Math.min(window.innerWidth * 0.90, 512)
        height = Math.min(window.innerHeight * 0.90, 512)
        width = Math.min(width, height);
        height = width;
	}
</script>

<svelte:window on:resize={handleSize} on:scroll={handleSize} />

<div class="strokewidth-mod" class:disabled={disabled}>
    <div class="svgwrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="{16+stroke_width}" height="{16+stroke_width}" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
        </svg>
    </div>
    <input type="range" name="strokewidth" id="strokewidth" bind:value={stroke_width} min={1} max={15} style="width: {width*0.8}px" step={0.1} disabled={disabled} />
</div>
<div class="wrapper">

{#if !disabled}
    <svg
        class={`sketch ${drawing||isnew ? "" : "error"}`}
        bind:this={svg}
        width={width}
        height={height}
        on:mouseleave={handleEnd}
        on:mousedown={e => {if (e.buttons === 1) handleStart(e)}}
        on:mousemove={handleMove}
        on:mouseup={handleEnd}
        on:touchstart={e => {
                        e.preventDefault()
                        const { clientX, clientY } = e.touches[0]
                        handleStart({
                            offsetX: clientX - l,
                            offsetY: clientY - t
                        })
                    }}
        on:touchmove={e => {
                        e.preventDefault()
                        const { clientX, clientY } = e.touches[0]
                        handleMove({
                            offsetX: clientX - l,
                            offsetY: clientY - t
                        })
                    }}
        on:touchend={handleEnd}
        style={{ touchAction: 'none' }}
    >
        {#each hist as pathD, i}
            <path class="sketch" d={pathD[0]} fill="none" stroke-width="{pathD[1]}px" stroke="black" />
        {/each}
    
        <path class="sketch" d={pathData} fill="none" stroke-width="{stroke_width > 15 ? 15 : stroke_width}px" stroke="black" />
    </svg>

    <button on:click={undo} class="undo" title="undo">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16" style="color: inherit;">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" fill="currentColor"/>
            <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" fill="currentColor"/>
        </svg>
    </button>
    <button on:click={clear} class="clear" title="clear">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="bi bi-trash3" viewBox="0 0 16 16" style="color: inherit;">
            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" fill="currentColor"/>
        </svg>
    </button>
{:else}
<svg bind:this={svg} class="sketch disabled" style="cursor: default" width={width} height={height}></svg>
{/if}
</div>

<canvas id="canvas" display="none" width={512} height={512} background="white"></canvas>

<style>

    .disabled {
        opacity: 50%;
    }
    .wrapper {
        position: relative;
        width:min-content;
        margin-inline: auto;
    }

    svg.sketch {
        cursor: crosshair;
        background-color: white;
        /* border: 3px solid var(--main-color); */
        border-radius: 10px;
        box-shadow: 0 2px 20px #6d6d6d;
    }
    canvas {
        display: none;
    }

    button {
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;

        position: absolute;
    }

    .error {
        border: 1px solid var(--mdc-theme-error, blue);
    }

    .undo {
        top: 6px;
        left: 6px;
        transition: 150ms ease-in-out;
    }
    .undo:hover, .undo:focus-visible {
        color: rgb(63, 223, 143);
    }

    .clear {
        top: 6px;
        right: 6px;
        transition: 150ms ease-in-out;
    }
    .clear:hover, .clear:focus-visible {
        color: rgb(223, 63, 76);
    }

    .play {
        bottom: 10px;
        right: 6px;
        transition: 150ms ease-in-out;
    }
    .play:hover, .play:focus-visible {
        color: rgb(44, 101, 223);
    }

    /* STYLIZING THE INPUT RANGE */

    .strokewidth-mod { 
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        margin-inline: auto;
    }
    .svgwrap {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 31px;
        height: 31px;
    }
    .svgwrap > svg {
        color: black;
    }

    input[type=range] {
        height: 38px;
        -webkit-appearance: none;
        background: transparent
    }
    input[type=range]:focus {
        outline: none;
    }
    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 10px;
        cursor: pointer;
        box-shadow: 1px 1px 1px #000000;
        background: var(--main-color);
        border-radius: 5px;
        border: 1px solid #000000;
    }
    input[type=range]::-webkit-slider-thumb {
        box-shadow: 1px 1px 1px #000000;
        border: 1px solid #000000;
        height: 30px;
        width: 15px;
        border-radius: 5px;
        background: #FFFFFF;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -11px;
    }
    input[type=range]:focus::-webkit-slider-runnable-track {
        background: var(--main-color);
    }
    input[type=range]::-moz-range-track {
        width: 100%;
        height: 10px;
        cursor: pointer;
        box-shadow: 1px 1px 1px #000000;
        background: var(--main-color);
        border-radius: 5px;
        border: 1px solid #000000;
    }
    input[type=range]::-moz-range-thumb {
        box-shadow: 1px 1px 1px #000000;
        border: 1px solid #000000;
        height: 30px;
        width: 15px;
        border-radius: 5px;
        background: #ffffff;
        cursor: pointer;
    }
    input[type=range]::-ms-track {
        width: 100%;
        height: 10px;
        cursor: pointer;
        background: transparent;
        border-color: transparent;
        color: transparent;
    }
    input[type=range]::-ms-fill-lower {
        background: var(--main-color);
        border: 1px solid #000000;
        border-radius: 10px;
        box-shadow: 1px 1px 1px #000000;
    }
    input[type=range]::-ms-fill-upper {
        background: var(--main-color);
        border: 1px solid #000000;
        border-radius: 10px;
        box-shadow: 1px 1px 1px #000000;
    }
    input[type=range]::-ms-thumb {
        margin-top: 1px;
        box-shadow: 1px 1px 1px #000000;
        border: 1px solid #000000;
        height: 30px;
        width: 15px;
        border-radius: 5px;
        background: #FFFFFF;
        cursor: pointer;
    }
    input[type=range]:focus::-ms-fill-lower {
        background: var(--main-color);
    }
    input[type=range]:focus::-ms-fill-upper {
        background: var(--main-color);
    }
</style>